'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("OffreEBEditionPopinController", function ($scope, $http, $q, contrepartieService, lovService, indexationService) {
  var isEdit = $scope.edit;
  $scope.searchExtraParams = {
    retireComptesSatellites: true
  };
  $scope.searchConfig = {
    stickToValue: "offre.compteNomInterne",
    labelAttribute: "nomInterne",
    searchUrl: "/rest/intra/comptes/search",
    extraParams: "searchExtraParams",
    resultTemplate: '<span class="name" ng-bind-html="result.nomInterne | underlineSearchResultMatch:search.q"></span>',
    onSelect: function onSelect(compte) {
      if (compte == null) {
        $scope.offre.compteId = null;
      } else {
        $scope.offre.compteId = compte.id;
      }
    }
  };
  $scope.penaliteFieldPrefix = "offre.penalite";
  $scope.typesModaliteIndexation = [{
    id: "FIXE",
    label: 'Fixe'
  }, {
    id: "VARIABLE",
    label: 'Variable'
  }];
  $scope.amortTypeIds = ["LINEAIRE", "CONSTANT", "IN_FINE", "A_LA_CARTE"];
  $q.when(lovService.getTypesPenaliteOptionRA()).then(function (typesPenaliteOptionRA) {
    $scope.typesPenalite = typesPenaliteOptionRA;
  });
  $q.when(lovService.getTypesPenaliteDegressive()).then(function (lov) {
    $scope.typesPenaliteDegressive = lov;
  });
  $q.when(lovService.getTauxPenaliteActuarielleIndex()).then(function (lov) {
    $scope.tauxPenaliteActuarielleIndex = lov;
  });
  $q.when(lovService.getTypesPenaliteActuarielle()).then(function (lov) {
    $scope.typesPenaliteActuarielle = lov;
  });
  $q.when(contrepartieService.getContreparties()).then(function (contreparties) {
    $scope.contreparties = contreparties;
  });
  $q.when(lovService.getTypesAmortissement()).then(function (typesAmortissement) {
    $scope.typesAmortissement = typesAmortissement;
  });
  $q.when(lovService.getPeriodicites()).then(function (periodicites) {
    $scope.periodicites = _.reject(periodicites, function (period) {
      return _.includes(["QUOTIDIENNE", "IN_FINE"], period.id);
    });
  });
  $q.when(indexationService.getIndicesClient()).then(function (indices) {
    $scope.indices = indices;
  });
  var initTauxMinMax = function initTauxMinMax() {
    // tauxMax
    $scope.tauxMax = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMax", function (tauxMax) {
      $scope.tauxMax = {
        checked: tauxMax != null,
        value: $scope.tauxMax.value || tauxMax
      };
    });
    $scope.$watch("tauxMax", function (tauxMax) {
      if (tauxMax.checked) {
        $scope.offre.indexation.tauxMax = tauxMax.value;
      } else {
        $scope.offre.indexation.tauxMax = null;
      }
    }, true);

    // tauxMin
    $scope.tauxMin = {
      checked: false,
      value: null
    };
    $scope.$watch("offre.indexation.tauxMin", function (tauxMin) {
      $scope.tauxMin = {
        checked: tauxMin != null,
        value: $scope.tauxMin.value || tauxMin
      };
    });
    $scope.$watch("tauxMin", function (tauxMin) {
      if (tauxMin.checked) {
        $scope.offre.indexation.tauxMin = tauxMin.value;
      } else {
        $scope.offre.indexation.tauxMin = null;
      }
    }, true);
  };
  $scope.offreFormConfig = {
    url: function url() {
      return '/rest/intra/offres/saisie/EB/save';
    },
    data: function data() {
      return $scope.offre;
    },
    customValidation: function customValidation() {
      var errors = [];
      if ($scope.offre) {
        if ($scope.offre.indexation.typeModaliteIndexation === 'FIXE' && $scope.offre.indexation.tauxFixe == null) {
          console.log('ADD error');
          errors.push({
            fieldName: 'indexation.tauxFixe',
            message: 'Le taux fixe est obligatoire.'
          });
        }
      }
      return errors;
    },
    // rajouté devant le fieldName des errors
    fieldPrefix: "offre.",
    onSuccess: function onSuccess(offre) {
      $scope.$close(offre);
    }
  };

  // permet d'injecter une offre déjà saisie (demande de financement)
  if ($scope.newOffre) {
    $scope.offre = $scope.newOffre;
    $scope.penalite = $scope.newOffre.penalite;
  } else
    // modification d'une offre existante
    if ($scope.offreId) {
      $http.get("/rest/intra/offres/saisie/EB/" + $scope.offreId).then(function (response) {
        console.log(response);
        $scope.offre = response.data;
        $scope.penalite = $scope.offre.penalite;
        initTauxMinMax();
      });
    } else {
      // nouvelle offre à partir d'une copie
      if ($scope.copieId) {
        $http.get("/rest/intra/offres/saisie/EB/" + $scope.copieId).then(function (response) {
          $scope.offre = response.data;
          $scope.penalite = $scope.offre.penalite;
          $scope.offre.id = null;
          initTauxMinMax();
        });
      } else {
        $scope.offre = {
          penalite: {},
          indexation: {},
          visibleClient: true
        };
        $scope.penalite = $scope.offre.penalite;
        initTauxMinMax();
      }
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/journalOffres/edition/offreEBEditionPopin.js
// module id = 2831
// module chunks = 13